import { gql } from 'graphql-request'

export namespace TicketStatusesQueries {
  export const QUERY_KEY = 'getTicketStatuses'

  export function getTicketStatuses() {
    return gql`
      query ticketStatuses {
        ticketStatuses {
          id
          internalDescription
          manualChangeAllowed
        }
      }
    `
  }
}
